const config = {
    "currentAcademicYearId": "6a20078bf78cc62472d2f8ea",
    "baseName": '/wested',
    basePath: '',
    //"basePath": 'http://localhost:9415/wested/',
    "SUB_END_DATE": "2029-07-31T00:00:00.000+00:00",
    "LAST_YEAR_END_DATE" : "2026-07-31T00:00:00.000+00:00"
}

export default config;